import React from "react";
import AuthSnsSignup from "@components/templates/AuthSnsSignup";
import { RootStackScreenProps } from "../types";

export default function AuthSnsSignupScreen({
  route,
}: RootStackScreenProps<"AuthSnsSignup">): JSX.Element {
  return <AuthSnsSignup data={route.params} />;
}
